import createReducer from '../utils/createReducer';
import actions from '../actions/purchaseOrder';
import {getComponentState} from '../utils/localStorageDataHandler';

const initialState = {};

const actionHandlers = {
    [actions.GET_PURCHASE_ORDER_SUCCESS](state, {payload}) {
        return {
            ...state,
            fileURL: payload.fileURL,
            file: payload.file,
            errorKey: false
        };
    },

    [actions.GET_PURCHASE_ORDER_ERROR](state, {payload}) {
        return {
            ...state,
            errorKeyPO: payload.errorKey,
            errorKeyApproval: false
        };
    },

    [actions.RECORD_APPROVAL_ERROR](state, {payload}) {
        return {
            ...state,
            errorKeyApproval: payload.errorKey,
            errorKeyPO: false
        };
    },

    [actions.PRE_POPULATE_LOCAL_STATE_PO](state, {payload}) {
        const stateData = getComponentState(payload.publicUuid, 'purchaseOrder');

        if (stateData && stateData.state) {
            state = stateData.state;
        }

        return {
            ...state
        };
    }
};

export default createReducer(actionHandlers, initialState);
